<template>
    <section-con main="教学全场景服务支持" sub="体系化的支持，让机构服务更加全面和高效">
       <div class="service-sup">
           <div class="service-sup-item">
               <div class="title-box">
                   <p class="title">3大运营支持</p>
               </div>
               <img-swiper :list="contentCopSupList"></img-swiper>
           </div>
           <div class="service-sup-item spc">
               <div class="title-box">
                   <p class="title">4大服务系统</p>
               </div>
               <columnList :list="contentLearn"></columnList>
           </div>
           <div class="service-sup-item">
               <div class="title-box">
                   <p class="title">5大教学场景</p>
               </div>
               <img class="situation-img" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-5-1.png">
           </div>
       </div>
    </section-con>
</template>
<script>
import imgSwiper from '../img-swiper'
import columnList from '../column-list'
import { contentCopSupList, contentLearn } from '@/const'
export default {
    data () {
        return {
            contentCopSupList: contentCopSupList,
            contentLearn: contentLearn
        }
    },
    components: { imgSwiper, columnList }
}
</script>
<style lang="scss" scoped>
.service-sup{
    .service-sup-item{
        margin-bottom: 40px;
        .title-box{
            width: 221px;
            height: 0px;
            border: 0px;
            border-top: 2px dotted #D8D8D8;
            position: relative;
            margin: 0 auto 30px;
            .title{
                font-size:14px;
                font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:#282828;
                line-height:20px;
                background: #ffffff;
                padding: 0px 10px;
                position: absolute;
                top: -9px;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        .content-img{
            width: 100%;
            margin-top: 30px;
            &.img1{
                width: 297px;
            }
        }
        &:last-of-type{
            margin-bottom: 0px;
        }
        &.spc{
            padding: 0px 20px;
        }
        .situation-img{
            width: 335px;
            margin: 0 auto;
        }
    }
}
</style>